import { cloneDeep } from 'lodash';
import { UUID } from 'v2/core/entities/uuid';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';

interface upsertQueryFilterNodeParams {
  parentID?: UUID;
  nodesByID: Record<string, NormalisedNode>;
  node: NormalisedNode;
}

export function upsertQueryFilterNode({
  parentID,
  nodesByID,
  node,
}: upsertQueryFilterNodeParams) {
  const updatedNodes = cloneDeep(nodesByID);

  if (!parentID) {
    updatedNodes[node.id] = node;
  } else {
    const group = updatedNodes[parentID];
    if (group.type !== 'group') {
      console.error("Can't add child to filter");
      return updatedNodes;
    }

    updatedNodes[node.id] = { ...node, parent: parentID };

    if (!group.children.includes(node.id)) {
      group.children = [...group.children, node.id];
    }
  }

  return updatedNodes;
}
